export default __webpack_public_path__ + "static/media/arrow-back-black.18cb0396.svg";